import Modal from "react-modal";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Button from "../shared/Button";

const engineerNotesStyle = {
    content: {
        width: "50%",
        maxHeight: "70%",
        margin: "auto",
        overflow: "auto",
    },
};

const EngineerNotesModal = ({ isOpen, onClose, notes, onSave }) => {
    const [items, setItems] = useState([]);

    // Initialise a working copy each time the dialog opens (mirrors the
    // desktop frmNotes: existing notes shown, or one blank note to start).
    useEffect(() => {
        if (isOpen) {
            const initial = Array.isArray(notes) ? notes : [];
            setItems(
                initial.length > 0
                    ? initial.map((n) => ({ id: n.id || uuidv4(), notes: n.notes ?? "" }))
                    : [{ id: uuidv4(), notes: "" }]
            );
        }
    }, [isOpen, notes]);

    const addNote = () =>
        setItems((prev) => [...prev, { id: uuidv4(), notes: "" }]);

    const updateNote = (id, value) =>
        setItems((prev) =>
            prev.map((n) => (n.id === id ? { ...n, notes: value } : n))
        );

    const deleteNote = (id) =>
        setItems((prev) => prev.filter((n) => n.id !== id));

    const handleSave = () => {
        // Persist only non-empty notes, preserving order.
        const cleaned = items
            .map((n) => ({ id: n.id, notes: (n.notes ?? "").trim() }))
            .filter((n) => n.notes.length > 0);
        onSave(cleaned);
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick={true}
            style={engineerNotesStyle}
            contentLabel="Engineer Notes"
        >
            <div className="grid gap-2">
                <h3 className="text-base font-semibold text-gray-900">
                    Engineer Notes
                </h3>

                {items.map((note, index) => (
                    <div
                        key={note.id}
                        className="grid gap-1 rounded-md border border-gray-200 p-2"
                    >
                        <div className="flex items-center justify-between">
                            <label className="block text-sm font-medium text-gray-700">
                                Note {index + 1}
                            </label>
                            <Button
                                text="Remove"
                                buttoncolor="disabled"
                                buttonSize="xs"
                                onClick={() => deleteNote(note.id)}
                            ></Button>
                        </div>
                        <textarea
                            rows={3}
                            value={note.notes}
                            onChange={(e) => updateNote(note.id, e.target.value)}
                            placeholder="Enter note"
                            className="block w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring-primary-500 text-sm"
                        />
                    </div>
                ))}

                {items.length === 0 && (
                    <p className="text-sm text-gray-500 py-2">
                        No notes added.
                    </p>
                )}

                <div>
                    <Button
                        text="Add Note"
                        buttoncolor="primary"
                        buttonSize="xs"
                        onClick={addNote}
                    ></Button>
                </div>

                <div className="flex flex-row gap-2 pt-2">
                    <Button
                        text="Save"
                        buttoncolor="primary"
                        buttonSize="xs"
                        onClick={handleSave}
                    ></Button>
                    <Button
                        text="Cancel"
                        buttoncolor="disabled"
                        buttonSize="xs"
                        onClick={onClose}
                    ></Button>
                </div>
            </div>
        </Modal>
    );
};

export default EngineerNotesModal;
